import { Box, Grid, Typography } from '@mui/material';
import { makeStyles, styled } from '@mui/styles';
import { Stack } from '@mui/system';
import React, { useState, useEffect } from 'react';
import ContainedButton from '../../../components/actions/ContainedButton';
import ErrorAlert from '../../../components/alerts/ErrorAlert';
import InputForm from '../../../components/forms/InputForm';
import BaseModal from '../../../components/modals/BaseModal';
import useUser from '../../../hooks/api/useUser';
import useForm from '../../../hooks/useForm';
import { GENDERS, LANGUAGES } from '../../../utils/enums';
import moment from 'moment-timezone';
import CeluIcon from '../../../components/platform/CeluIcon';
import cartIcon from '../../../assets/icons/ecommerce/shopping-cart.svg'
import useCart from '../../../hooks/api/useCart';
const StyledRoot = styled('div')(({ theme }) => ({
    //right: 0,
    //bottom: 0,
    //zIndex: 9998,
    width: '100%',
    minHeight: '30vh',
    //position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
  }));

const AddCartModal = (props) => {

    const {open, onClose, onRefresh, onCompleted} = props
    const  classes = useStyles()
    const [sending, setSending] = useState(false)
    const [error, setError] = useState()
    const cartManager = useCart()
    const controller = useForm(form_data)
    const {form, onChangeForm, onResetForm, onGetFormData} = controller


    useEffect(() => {
    },[open])

    const onSubmit = async() => {


        setSending(true)
        const data2send = onGetFormData()

        try {
            console.log('Send data', data2send)
            const response = await cartManager.actions.onAddTemplate(data2send)
            console.log(response)
            await onCompleted({id_cart:response})
            await onRefresh()

        } catch (error) {
            setError(error)
            setSending(false)
            return
        }

        setSending(false)
        onClose()

    }

    return ( 
        <BaseModal maxWidth='xs'
        title=''
        open={open} 
        onClose={onClose} >
            <StyledRoot>
                <div>
                    <Stack alignItems='center' spacing={2}>
                        <div>
                            <CeluIcon size='large' icon={cartIcon}/>
                        </div>
                        <Typography variant='h5' align='center' sx={{maxWidth:300}} >
                            ¿Está seguro de crear un nuevo carrito?
                        </Typography>
                        <Box sx={{marginTop:4, marginBottom:16, width:'100%'}}>
                            <InputForm data={form.alias} onChange={onChangeForm}/>
                        </Box>
                        {error && 
                            <ErrorAlert 
                            error={error} 
                            onClose={() => setError(null)} />
                        }
                        <ContainedButton disabled={!form?.alias?.isValid} loading={sending} onClick={onSubmit}>
                            Continuar
                        </ContainedButton>
                    </Stack>
                </div>
            </StyledRoot>
        </BaseModal>
     );
}

const useStyles = makeStyles(theme => ({
    description:{
        marginBottom:16
    }
}))
 
export default AddCartModal;

const form_data = {
    alias: {
        value:'',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'alias',
            type: 'text',
            fullWidth: true,
            label:'Nombre del carrito',
            placeholder:'Nombre del carrito',
            helperText:'Debe de contener de 1 a 255 caracteres '
        },
        rules: {type: 'distance', min:1, max:255}
    },
}

